import { render, staticRenderFns } from "./TicketsFilters.vue?vue&type=template&id=2020d620&"
import script from "./TicketsFilters.vue?vue&type=script&lang=ts&"
export * from "./TicketsFilters.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsFilters.vue?vue&type=style&index=0&id=2020d620&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports